import React from "react";
import { Button, Input } from "@deeptrue-frontend/ui";
import { Formik, Form, Field as FormikField, FormikHelpers } from "formik";
import styled from "styled-components/macro";
import * as Yup from "yup";
import { FormatMessage } from "components/IntlProvider/hooks/hooks";
import { useFormatMessage } from "components/IntlProvider";

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 3rem;
`;

const FormStyled = styled(Form)`
  margin-top: 2rem;
  width: 35rem;
`;

export type FormValues = {
  name: string;
  users?: number[] | null;
};

interface Props {
  onSubmit: (values: FormValues, helpers: FormikHelpers<FormValues>) => void;
  closeModal: () => void;
}

const getValidationSchema = (t: FormatMessage) =>
  Yup.object().shape<any>({
    name: Yup.string().required(
      t("errors.fields.required", "Field is required")
    ),
  });

const AddGroup = ({ onSubmit, closeModal }: Props) => {
  const t = useFormatMessage();
  return (
    <Formik
      initialValues={{
        name: "",
        users: [],
      }}
      onSubmit={onSubmit}
      validationSchema={getValidationSchema(t)}
    >
      {({ handleSubmit, touched, errors, setFieldValue }) => {
        return (
          <FormStyled onSubmit={handleSubmit}>
            <FormikField
              name="name"
              as={Input}
              hasError={touched.name && errors.name}
              helperText={touched.name && errors.name}
              label={t("organization.columns.name", "Name")}
            />

            <ButtonWrapper>
              <Button
                style={{ textTransform: "capitalize" }}
                type="button"
                variant="outlined"
                onClick={closeModal}
              >
                {t("pages.project.modal.cancel", "Cancel")}
              </Button>
              <Button ml="1rem" type="submit" variant="primary">
                {t("pages.project.modal.create", "Create")}
              </Button>
            </ButtonWrapper>
          </FormStyled>
        );
      }}
    </Formik>
  );
};

export default AddGroup;
